import { createStore } from 'redux'
import { createMigrate, persistStore, persistCombineReducers, MigrationManifest } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2'

import reduxMigration from './reduxMigration'

// integrate the app specific rducers that include ../batikore reducer
import reducers from '../reducers'

const persistConfig = {
  key: 'root',
  storage: storage,
  version: 4,
  stateReconcilier: autoMergeLevel2, //see 'merge section for detail'
  migrate: createMigrate(reduxMigration as unknown as MigrationManifest, { debug: true })
}

const persistReducer = persistCombineReducers(persistConfig, reducers)
let store = createStore(persistReducer)
if (process.env.NODE_ENV !== 'production') {
  // const logger = createLogger({
  //   predicate: () => isDev,
  //   collapsed: true,
  //   duration: true
  //   // diff: true
  // })

  // let reduxDebugger = createDebugger()
  store = createStore(persistReducer)
} else {
  store = createStore(persistReducer)
}

// const logger = createLogger({
//   predicate: () => isDev,
//   collapsed: true,
//   duration: true
// })

// Setup redux middleware

export const persistor = persistStore(store)

export default { store, persistReducer }
